<template lang="pug">
.form-location.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.location" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.location }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="location" title="Ubicación")
      .input-container
        input.input(v-model="dataForm.department" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.department }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="department" title="Departamento")

    .divider

    .form-section
      .input-container.arrow
        select.select.capitalize(v-model="dataForm.preferedConveyor"  autocomplete="ño")
          option(value="")
          option(v-for="conveyor in conveyors" :value="conveyor") {{ conveyor }}
        label.label(:class="{ show: dataForm.preferedConveyor }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="preferedConveyor" title="Transportadora Preferida")

      .input-container
        input.input(v-model.number="dataForm.conveyorCost" type="number" autocomplete="ño")
        label.label(:class="{ show: dataForm.conveyorCost }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="conveyorCost" title="Costo de la Transportadora")

    .divider

    .form-section
      shSelectList(:dataForm="dataForm" :dataOriginal="dataOriginal" :fillData="fillData" property="availableMethods" title="Método de Pago" :options="methods" :required="0" :caps="true")

    .divider

    .form-section
      shInputListNumber(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Costo Del Método de Pago" property="availableMethodsCost" :fillData="fillData" type="number" :required="0" :min="-1" :max="30000")

    // .form-section
      .input-container
        input.input(v-model="dataForm.idCoordinadora" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.idCoordinadora }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="idCoordinadora" title="Código Coordinadora")

      .input-container
        input.input(v-model="dataForm.nameCoordinadora" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.nameCoordinadora }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="nameCoordinadora" title="Nombre Coordinadora")

      .input-container
        input.input(v-model="dataForm.abbreviatedCoordinadora" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.abbreviatedCoordinadora }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="abbreviatedCoordinadora" title="Abreviatura Coordinadora")

      .input-container
        input.input(v-model="dataForm.codeCmCoordinadora" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.codeCmCoordinadora }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="codeCmCoordinadora" title="Código CM Coordinadora")

      .input-container
        input.input(v-model="dataForm.codeTerminalCoordinadora" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.codeTerminalCoordinadora }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="codeTerminalCoordinadora" title="Código Terminal Coordinadora")

      .input-container
        input.input(v-model="dataForm.labelCoordinadora" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.labelCoordinadora }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="labelCoordinadora" title="Etiqueta Coordinadora")

      .input-container
        input.input(v-model="dataForm.nameTerminalCoordinadora" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.nameTerminalCoordinadora }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="nameTerminalCoordinadora" title="Nombre Terminal Coordinadora")

    .left
      h3 Activo en Marca

    .input-container.arrow(v-for="(brand, index) in brands")
      select.select(v-model="dataForm.activeLocation[index]" autocomplete="ño" required)
        option(:value="true") Activo
        option(:value="false") Inactivo
      label.label(:class="{ show: dataForm.activeLocation[index] }")
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="activeLocation" :index="index" :title="brand")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteLocation")
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gqlLocation from '@/graphql/location'
import shSelectList from '@/components/elements/SelectList'
import shInputListNumber from '@/components/elements/InputListNumber'

export default {
  name: 'FormLocation',

  mixins: [mForm, mDB],

  components: { shSelectList, shInputListNumber },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        location: '',
        department: '',
        availableConveyors: [''],
        availableMethods: [''],
        availableConveyorsCost: [''],
        availableMethodsCost: [''],
        active: false,
        preferedConveyor: '',
        conveyorCost: ''
      },
      resolver: 'location',
      key: 'location',
      findKey: '_id',
      gql: gqlLocation
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newLocation()
      } else {
        this.updateLocation()
      }
    },

    newLocation () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateLocation () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteLocation () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  computed: {
    conveyors () {
      return this.$store.state.variables.conveyors
    },
    methods () {
      return this.$store.state.variables.methods
    },
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-location
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/location/Form.vue